import React, {useEffect, useState} from 'react';
import ProjectPageHeader from "../layouts/ProjectPageHeader"
import {CompletionRequests} from "../../api/requests/CompletionRequests"
import {useProjectData} from "../../hooks/useProjectData"
import ApiError from "../../api/ApiError"
import {CompletionRequestJson} from "../../api/json/CompletionRequestJson"
import CompletionsTable from "./CompletionsTable"
import CompletionDetailsModal from "./CompletionDetailsModal"
import ErrorMessage from "../error/ErrorMessage"
import {useBreadcrumbs} from "../layouts/Nav/BreadcrumbsProvider"
import {NAV_LABELS} from "../../library/NavLabels"

function CompletionsPage() {
    useBreadcrumbs([{label: NAV_LABELS.HISTORY}])
    const {id, project} = useProjectData()

    const [requests, setRequests] = useState<CompletionRequestJson[]>([])
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [rowCount, setRowCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<ApiError>()

    const [detailsRequest, setDetailsRequest] = useState<CompletionRequestJson | null>(null)

    useEffect(() => {
        if (!id) return
        let cancelled = false
        setLoading(true)
        CompletionRequests.listByProject(id, page)
            .then(response => {
                if (cancelled) return
                setRequests(response.content)
                setRowCount(response.totalElements)
                if (response.size) setPageSize(response.size)
                setError(undefined)
            })
            .catch(e => {
                if (cancelled) return
                setError(e)
            })
            .finally(() => {
                if (cancelled) return
                setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [id, page])

    if (!project) {
        return <>No project</>
    }

    return (
        <>
            <ProjectPageHeader pageTitle="History"/>

            {error && <ErrorMessage error={error} sx={{mb: 2}}/>}

            <CompletionsTable
                requests={requests}
                page={page}
                pageSize={pageSize}
                rowCount={rowCount}
                loading={loading}
                onPageChange={setPage}
                onRowClick={setDetailsRequest}
            />

            <CompletionDetailsModal
                open={detailsRequest !== null}
                onClose={() => setDetailsRequest(null)}
                request={detailsRequest}
            />
        </>
    );
}

export default CompletionsPage;
